export class FsrV1 {
    constructor(socket) {
        this.socket = socket;
        this.power = false;
        this.videoMatrixRoutes = 'hdmi1';
        this.volume = 50;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'autoSwitch',
                regExp: /set autosw_onoff (on|off)/i,
                callback: (match) => {
                    this.socket.send(`Auto Switch: ${match[1]}`);
                },
            },
            {
                name: 'initializeStep',
                regExp: /set api_onoff (on|off)/i,
                callback: (match) => {
                    this.socket.send(`API Mode: ${match[1]}`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /get scaler_status/i,
                callback: (match) => {
                    this.socket.send(`standby_status ${this.power ? 'off' : 'on'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /set standby_onoff (.+)/i,
                callback: (match) => {
                    this.power = match[1] === 'off';
                    this.socket.send(`standby_onoff ${this.power ? 'off' : 'on'}`);
                },
            },
            {
                name: 'videoMatrixRoutesQuery',
                regExp: /get sw_status/i,
                callback: (match) => {
                    this.socket.send(`Source Select: ${this.videoMatrixRoutes.toUpperCase()}`);
                },
            },
            {
                name: 'videoMatrixRoutesSet',
                regExp: /set sw (.+)/i,
                callback: (match) => {
                    this.videoMatrixRoutes = match[1];
                    this.socket.send(`Source Select: ${this.videoMatrixRoutes.toUpperCase()}`);
                },
            },
            {
                name: 'volumeQuery',
                regExp: /get volgain_data audioout/i,
                callback: (match) => {
                    this.socket.send(`VOLGAIN_DATA audioout ${this.volume}`);
                },
            },
            {
                name: 'volumeSet',
                regExp: /set volgain_data audioout (.+)/i,
                callback: (match) => {
                    this.volume = parseInt(match[1], 10);
                    this.socket.send(`VOLGAIN_DATA audioout ${this.volume}`);
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /get audio_mute audioout/i,
                callback: (match) => {
                    this.socket.send(`AUDIOOUT_MUTE audioout ${this.volumeMute ? 'on' : 'off'}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /set AUDIO_MUTE audioout (.+)/i,
                callback: (match) => {
                    this.volumeMute = match[1] === 'on';
                    this.socket.send(`AUDIOOUT_MUTE audioout ${this.volumeMute ? 'on' : 'off'}`);
                },
            },
        ];
    }
}
FsrV1.emulatorType = 'socketEmulator';
FsrV1.key = '-KonV1xSDtrP8VXYosLW';
